import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../Assets/image 2236.png";
import { FaWallet } from "react-icons/fa";
import { Modal, ModalBody } from "reactstrap";
import {
  loginUser,
  signupUser,
  sendForgotPasswordOtp,
  resetPassword
} from "../Common/auth.js";
import logo2 from "../Assets/Logo.png";

function Navbar({ loginupdate }) {
  const [showWallet, setShowWallet] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("isLoggedIn") === "true"
  );
  const userData = localStorage.getItem("AluraUser");
  const parseData = userData && JSON.parse(userData);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const toggleDivRef = useRef(null);
  const [isDivVisible, setIsDivVisible] = useState(false);
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password2, setPassword2] = useState("");
  const [mobile, setMobile] = useState("");
  const [dob, setdob] = useState("");
  const [loading, setLoading] = useState(false);
  const [registerLoading, setRegisterLoading] = useState(false);
  const [otpEmail, setOtpEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  useEffect(() => {
    if (loginupdate > 0) {
      setModal(true);
    }
  }, [loginupdate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowWallet(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isDivVisible) {
      document.addEventListener("mousedown", handleClickOutsideToggle);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideToggle);
    }
    return () =>
      document.removeEventListener("mousedown", handleClickOutsideToggle);
  }, [isDivVisible]);

  const handleLogin = async () => {
    if (!username || !password) {
      alert("Please enter username and password");
      return;
    }

    setLoading(true); // Start loader

    try {
      const response = await loginUser({ email: username, password });
      if (response.statusCode === 200) {
        const data = response.data;
        alert("Login Successful!");
        setIsLoggedIn(true);

        localStorage.setItem("AluraUser", JSON.stringify(data.user));
        localStorage.setItem("AluraToken", data.token);
        localStorage.setItem("isLoggedIn", "true");

        setModal(false);
        navigate("/bookclasses");
      } else {
        alert("Invalid Username or Password");
      }
    } catch (error) {
      console.error("Login Error:", error);
      alert(error.response?.data?.message || "Login failed");
    } finally {
      setLoading(false); // Stop loader
    }
  };

  const handleRegister = async () => {
    if (!name || !email || !password2 || !mobile) {
      alert("Please fill all the fields");
      return;
    }

    setRegisterLoading(true); // Start spinner

    try {
      const response = await signupUser({
        name,
        email,
        password: password2,
        mobile,
        dob
      });

      if (response.statusCode === 200) {
        alert("Signup Successful!");
        setIsLoggedIn(true);
        const data = response.data;
        localStorage.setItem("AluraUser", JSON.stringify(data.user));
        localStorage.setItem("AluraToken", data.token);
        localStorage.setItem("isLoggedIn", "true");

        setModal2(false);
        navigate("/bookclasses");
        // setModal(true);
        // navigate("/");
      } else {
        alert("Signup Failed. Try Again!");
      }
    } catch (error) {
      console.error("Signup Error:", error);
      alert(error.response?.data?.message || "Signup failed");
    } finally {
      setRegisterLoading(false); // Stop spinner
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("AluraUser");
    localStorage.removeItem("AluraToken");
    setShowWallet(false);
    alert("Logged Out!");
  };

  const handleSendOtp = async () => {
    if (!otpEmail) {
      alert("Please enter your email");
      return;
    }

    setOtpLoading(true); // Start loader
    try {
      const response = await sendForgotPasswordOtp({ email: otpEmail });
      if (response.statusCode === 200) {
        alert("OTP sent successfully to your email!");
      } else {
        alert("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      console.error("OTP Send Error:", error);
      alert(error.response?.data?.message || "Failed to send OTP");
    } finally {
      setOtpLoading(false); // Stop loader
    }
  };

  const handleResetPassword = async () => {
    if (!otpEmail || !otp || !newPassword) {
      alert("Please fill all the fields");
      return;
    }

    setResetLoading(true); // Start loader
    try {
      const response = await resetPassword({
        email: otpEmail,
        otp,
        password: newPassword
      });
      if (response.statusCode === 200) {
        alert("Password reset successfully!");
        setModal3(false);
        setModal(true);
      } else {
        alert("Failed to reset password. Please try again.");
      }
    } catch (error) {
      console.error("Reset Password Error:", error);
      alert(error.response?.data?.message || "Failed to reset password");
    } finally {
      setResetLoading(false); // Stop loader
    }
  };

  const openToggleDiv = () => setIsDivVisible(true);
  const closeToggleDiv = () => setIsDivVisible(false);

  const handleClickOutsideToggle = (event) => {
    if (toggleDivRef.current && !toggleDivRef.current.contains(event.target)) {
      closeToggleDiv();
    }
  };

  return (
    <>
      {/* <div className="topnav">
        <p>
          Sign up and get 20% off on your first order.{" "}
          <span style={{ cursor: "pointer" }} onClick={() => setModal2(true)}>
            Sign Up Now
          </span>
        </p>
      </div> */}

      <nav>
        <div className="nav-div">
          <div className="left-wallet">
            {!isLoggedIn ? (
              <button onClick={() => setModal(true)}>Log In</button>
            ) : (
              <div className="relative">
                <p
                  ref={buttonRef}
                  onClick={() => setShowWallet(!showWallet)}
                  className="profile-btn"
                >
                  <FaWallet style={{ color: "#fff" }} size={25} />
                </p>

                {showWallet && (
                  <div ref={dropdownRef} className="wallet-dropdown active">
                    <div
                      className="person"
                      onClick={() => navigate("/profile")}
                    >
                      <i className="bi bi-person-circle"></i>
                      <p style={{ marginTop: "8px" }}>Hi,{parseData?.name}</p>
                    </div>
                    <button
                      className="logout"
                      onClick={() => navigate("/profile")}
                      style={{
                        marginTop: "8px",
                        cursor: "pointer",
                        width: "100%"
                      }}
                    >
                      View Profile
                    </button>
                    <br />

                    {/* <div className="wallet-header">
                  {/* <div className="wallet-header">
                    <span>Remaining Classes</span>
                  </div>
                  <p className="wallet-balance">Completed: 3 Classes</p>
                  <p className="wallet-balance">Remaining: 4 Classes</p> */}
                    {/* <br />
                  <button className='logout' style={{ width: '100%', display: 'block' }} onClick={handleLogout}>Logout</button> */}
                  </div>
                )}
              </div>
            )}
          </div>
          <Link to="/">
            <img src={logo} className="nav-logo" alt="Logo" />
          </Link>
          <ul>
            <Link className="none" to="/">
              <li>Home</li>
            </Link>
            <Link className="none" to="/about">
              <li>About Us</li>
            </Link>
            <Link className="none" to="/bookclasses">
              <li>Classes</li>
            </Link>
            <Link className="none" to="/Package">
              <li>Packages</li>
            </Link>
            <Link className="none" to="/services">
              <li>Services</li>
            </Link>

            <Link className="none" to="/contact">
              <li>Contact</li>
            </Link>
            <div className="wlt-div">
              <div className="rightwallect">
                {!isLoggedIn ? (
                  <button onClick={() => setModal(true)}>Log In</button>
                ) : (
                  <div className="relative">
                    <p
                      ref={buttonRef}
                      onClick={() => setShowWallet(!showWallet)}
                      className="profile-btn"
                    >
                      <FaWallet style={{ color: "#fff" }} size={25} />
                    </p>

                    {showWallet && (
                      <div ref={dropdownRef} className="wallet-dropdown active">
                        <div
                          className="person"
                          onClick={() => navigate("/profile")}
                        >
                          {/* <i className="bi bi-person-circle"></i> */}
                          <p style={{ marginTop: "8px" }}>
                            Hi,{parseData?.name}
                          </p>
                        </div>
                        <button
                          className="logout"
                          style={{
                            marginTop: "10px",
                            cursor: "pointer",
                            width: "100%"
                          }}
                          onClick={() => navigate("/profile")}
                        >
                          View Profile
                        </button>
                        {/* <div className="wallet-header">
                      <span>Remaining Classes</span>
                    </div>
                    <p className="wallet-balance">Completed: 3 Classes</p>
                    <p className="wallet-balance">Remaining: 4 Classes</p> */}
                        <br />
                        <br />
                        <button
                          className="logout"
                          style={{ width: "100%", display: "block" }}
                          onClick={handleLogout}
                        >
                          Logout
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <i
                style={{ color: "black", cursor: "pointer" }}
                className="bi bi-list"
                onClick={isDivVisible ? closeToggleDiv : openToggleDiv}
              ></i>
            </div>
          </ul>
          <i
            style={{ color: "white", cursor: "pointer" }}
            className="bi bi-list"
            onClick={isDivVisible ? closeToggleDiv : openToggleDiv}
          ></i>
        </div>
      </nav>

      {isDivVisible && (
        <div className="toggleDiv-ops">
          <div className="toggleDiv" ref={toggleDivRef}>
            <ul>
              <Link className="none" to="/">
                <li>Home</li>
              </Link>
              <Link className="none" to="/about">
                <li>About Us</li>
              </Link>
              <Link className="none" to="/bookclasses">
                <li>Classes</li>
              </Link>
              <Link className="none" to="/Package">
                <li>Packages</li>
              </Link>
              <Link className="none" to="/services">
                <li>Services</li>
              </Link>

              <Link className="none" to="/contact">
                <li>Contact</li>
              </Link>

              {!isLoggedIn ? (
                <>
                  <button onClick={() => setModal(true)}>Login</button>
                  <br />
                  <br />
                  <button onClick={() => setModal2(true)} className="sing-nav">
                    Signup
                  </button>
                </>
              ) : (
                <button onClick={handleLogout} className="logout-btn">
                  Logout
                </button>
              )}
            </ul>
          </div>
        </div>
      )}

      {/* Login Modal */}
      <Modal size="lg" isOpen={modal} toggle={() => setModal(!modal)}>
        <ModalBody>
          <div className="login-div">
            <img src={logo2} alt="Logo" />
            <br />
            <div className="login-heading">
              <h1>Login</h1>
              <p
                onClick={() => {
                  setModal(false);
                  setModal2(true);
                }}
              >
                Don't Have An Account? <br />{" "}
                <span style={{ cursor: "pointer" }}>Sign Up</span>
              </p>
            </div>
            <br />
            <div className="login-div2">
              <label>Email</label>
              <input
                type="text"
                placeholder="Enter Your Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              <br />
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter Your Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <br />
              <p
                onClick={() => {
                  setModal(false);
                  setModal3(true);
                }}
              >
                Forget Password
              </p>
              <button onClick={handleLogin} disabled={loading}>
                {loading ? <span className="spinner" /> : "Login"}
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Signup Modal */}
      <Modal size="lg" isOpen={modal2} toggle={() => setModal2(!modal2)}>
        <ModalBody>
          <div className="login-div">
            <img src={logo2} alt="Logo" />
            <br />
            <div className="login-heading">
              <h1>Signup</h1>
              <p
                onClick={() => {
                  setModal2(false);
                  setModal(true);
                }}
              >
                Already Have an Account? <br /> Login
              </p>
            </div>
            <br />
            <div className="login-div2">
              <label>Full Name</label>
              <input
                type="text"
                placeholder="Enter Your Full Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <br />
              <label>Date Of Birth</label>
              <input
                type="date"
                placeholder="Date Of Birth"
                value={dob}
                onChange={(e) => setdob(e.target.value)}
              />
              <br />

              <label>Email</label>
              <input
                type="email"
                placeholder="Enter Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <br />
              <label>Mobile No.</label>
              <input
                type="number"
                placeholder="Enter Your Mobile No"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
              <br />
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter Your Password"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
              />
              <div className="checkterms">
                <input type="checkbox" />
                <p style={{ fontFamily: "Merriweather" }}>
                  Accept{" "}
                  <Link
                    to="/tnc"
                    style={{ color: "#849348", textDecoration: "none" }}
                  >
                    Terms and Conditions
                  </Link>
                </p>
              </div>

              <br />
              {/* <label>Password</label>
              <input type="password" placeholder="Enter Your Password" />
              <br /> */}
              <button onClick={handleRegister} disabled={registerLoading}>
                {registerLoading ? <span className="spinner" /> : "Sign Up"}
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Login Modal */}
      <Modal size="lg" isOpen={modal3} toggle={() => setModal3(!modal3)}>
        <ModalBody>
          <div className="login-div">
            <img src={logo2} alt="Logo" />
            <br />
            <div className="login-heading">
              <h1>Forget Password</h1>
            </div>
            <br />
            <div className="login-div2">
              <label>Email</label>
              <div className="Verify-otp">
                <input
                  type="email"
                  placeholder="Enter Your Email"
                  value={otpEmail}
                  onChange={(e) => setOtpEmail(e.target.value)}
                />
                <button onClick={handleSendOtp} disabled={otpLoading}>
                  {otpLoading ? <span className="spinner" /> : "Send OTP"}
                </button>
              </div>
              <br />
              <label>Enter OTP</label>
              <div className="Verify-otp">
                <input
                  type="text"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
              </div>
              <br />
              <label>Set Password</label>
              <input
                type="password"
                placeholder="Enter New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <br />
              <button onClick={handleResetPassword} disabled={resetLoading}>
                {resetLoading ? <span className="spinner" /> : "Update"}
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default Navbar;
